import { type FC } from 'react'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

import { Experiment } from '../../../../../experiments/components/Experiment'
import { ExperimentVariant } from '../../../../../experiments/components/ExperimentVariant'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP } from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { ProductSellerPromotionInfoBanner } from '../../../ProductSellerPromotionInfoBanner/ProductSellerPromotionInfoBanner'

export const ProductOfferCardSellerPromotionInfoBanner: FC<{
  offer: OfferV11
  product: PimProductWithVariantsV1
}> = ({ offer, product }) => {
  return (
    <Experiment names={[EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP]}>
      <ExperimentVariant name={EXPERIMENT_VARIATION.DEFAULT}>
        <ProductSellerPromotionInfoBanner
          className="mt-6 items-center"
          offer={offer}
          product={product}
          size="xs"
        />
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V1}>
        {null}
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V2}>
        {null}
      </ExperimentVariant>
    </Experiment>
  )
}
